import * as React from 'react';
import styled, { css } from 'styled-components';
import { ButtonProgressIcon } from './ButtonProgressIcon';

interface Props {
  loading?: boolean;
}

/**
 * @deprecated use Button from @beeline.com/bp-design-system
 */
export const ButtonWrapperWithLoadingIcon: React.FC<React.PropsWithChildren<Props>> = ({ children, loading }) => (
  <StyledButtonContainer $isLoading={loading}>
    {children}
    <ButtonProgressIcon
      style={{
        opacity: loading ? 1 : 0,
        display: loading ? 'inline-block' : 'none',
        position: 'absolute',
        left: '50%',
        top: '50%',
        marginLeft: -10,
        marginTop: -10,
        transition: '0.2s opacity ease-in-out'
      }}
    />
  </StyledButtonContainer>
);

const StyledButtonContainer = styled.span<{ $isLoading?: boolean }>`
  position: relative;
  margin: 0;

  ${({ $isLoading }) => ($isLoading ? hideText : '')}
`;
StyledButtonContainer.displayName = 'ButtonContainer';

const hideText = css`
  pointer-events: none;
  button {
    color: transparent !important;
  }
`;
